import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../../assets/images/icons/user-dashboard/trash-icon.png';

import CustomModalView from '../../../common/input/customModal/customModalView';
import { Navigate } from 'react-router-dom'


const CandidatesDashboardView = (props) => {

    // if (localStorage.getItem("token") != null && localStorage.getItem("is_admin")) {
        return (
            <>
                <div className="dashboard-body-area" style={{ width: '100%' }}>
                    <section className="dashboard-page-title">
                        <div className="row justify-content-md-center">

                            <div className="col-md-4 findjob-search-bar">
                                <div className="cc-searchbar" style={{ width: "95%" }}>
                                    <div className="srch-fld-row">
                                        <div className="srch-fld-col" style={{ width: '82%', borderRight: "0px" }}><input type="text" placeholder="Postcode" /></div>

                                        <div className="srch-fld-col srch-btn-col">
                                            <input type="submit" value="" className="form-submit-btn" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 ">
                                <div className="form-group">
                                    <select id="inputcare" className="cc-searchbar form-control" style={{ height: '59px' }}>
                                        <option>Column View</option>
                                    </select>
                                </div>
                            </div>
                            <div className="col-md-3 ">
                                <div className="form-group">
                                    <select id="inputcare" className="cc-searchbar form-control" style={{ height: '59px' }}>
                                        <option>Status</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                    </section>
                    <section className="dashboard-page-title">
                        <h2>Candidate's Dashboard</h2>
                    </section>
                    <div className="table-area applied-job-table">
                        <Table responsive>
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>First Name</th>
                                    <th>Last Name</th>
                                    <th>Email</th>
                                    <th>Zipcode</th>
                                    <th>Country</th>
                                    <th>City</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.candidates_detail.map((candidate, index) => (
                                    <tr>
                                        <td>{candidate.id}</td>
                                        <td><span className="title-crop">{candidate.first_name}</span></td>
                                        <td>{candidate.last_name}</td>
                                        <td>{candidate.email}</td>
                                        <td>{candidate.zipcode}</td>
                                        <td>{candidate.country}</td>
                                        <td>{candidate.city}</td>
                                        {candidate.applicant_status ?
                                            <td>{candidate.applicant_status.applicant_real_status}</td>
                                            :
                                            <td></td>
                                        }
                                        <td >
                                            <div style={{ display: "flex", flexDirection: "row" }}>
                                                <div>
                                                    <Link href="" onClick={(e) => props.handlepreview(candidate.id)} className="del_btn"><i style={{ margin: '0 8px', color: 'black' }} class="fa fa-eye fa-lg" aria-hidden="true"></i></Link>
                                                </div>
                                                <div>
                                                    {candidate.filepath ?
                                                        <a href={candidate.filepath} className="del_btn"><i style={{ margin: '0 8px' }} class="fa fa-download fa-lg" aria-hidden="true"></i></a>
                                                        :
                                                        <a className="del_btn"></a>
                                                    }</div>
                                                <div>
                                                    <Link href="" className="del_btn" onClick={(e) => props.handledelete(candidate.id)}><img style={{ margin: '0 8px', width: "16px" }} src={trash_icon} /></Link>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}

                            </tbody>
                        </Table>
                    </div>
                </div>
                <CustomModalView
                    modal_show={props.modal_show}
                    authResponse={props.authResponse}
                    showCustomModal={props.showCustomModal}
                    hideCustomModal={props.hideCustomModal}
                />
            </>
        )
    // }
    // else if (localStorage.getItem("token") == null) {
    //     return (
    //         <Navigate to="/login" />
    //     )
    // }
    // else {
    //     return (
    //         <Navigate to="/dashboard" />
    //     )
    // }
}

export default CandidatesDashboardView;